<template>
      <div :class="{carddivcss: carddivtheme==='carddivcss'}">
        <div class="row " >
          <div class="col-xs-3 col-sm-6 col-md-2 g-0" v-for="sdgs in getallgoalsmapping">
            <div v-for="sdgsls in getallsdgslisting">
                <span v-if="sdgsls.sdgsid === sdgs.Sdgs">
                    <img class="card-img-top shadow " :src="`${myPicUrl}${sdgsls.sdgsimage}`">
                </span>
            </div>
          </div>
        </div>
      </div>
  
     
  </template>
    
    <script>
    require('@/globalDeclare.js');

    export default{
    props: ['getallgoalsmapping', 'getallsdgslisting', 'carddivtheme'],
    data(){ 
        return{
            myPicUrl: '',
        }
    },
    methods: {
    },
    mounted() {
    this.myPicUrl = myUrlPath
    }
    }
    </script>
    
    <style scoped>
    /*===================MEDIA SCREENS TAMPLATES===============*/
     /* Extra small devices (phones, 600px and down) */
  
     .card-img-top {
      border-radius: 7px;
      width: 240px;
      margin-left: -8px;
      margin-bottom: 20px;
     }

     .carddiv {
      padding-bottom: 30px;
      padding-left: 120px;
      margin-top: -70px;
    }

     @media only screen and (max-width: 600px) {
      .col {
        max-width: 45%;
      }
      .carddiv {
        width: 100%;
      }

      .card-img-top {
        border-radius: 7px;
        width: 180px;
        margin-bottom: 20px;
        margin-left: 140px;
       }
    }
    
     /* Small devices (portrait tablets and large phones, 600px and up) */
     @media only screen and (min-width: 600px) {
      .col {
        max-width: 45%;

      }
      .carddiv {
        width: 90%;
      }

      .card-img-top {
        border-radius: 7px;
        width: 150px;
        margin-right: 50px;
        margin-bottom: 20px;
       }
     }
     
     /* Medium devices (landscape tablets, 768px and up) */
     @media only screen and (min-width: 768px) {
      .col {
        margin-right: 3px;
      }
      .card-img-top {
        border-radius: 7px;
        width: 100px;
        margin-right: 50px;
        margin-bottom: 20px;
       }
      
     }
    
     
     /* Large devices (laptops/desktops, 992px and up) */
     @media only screen and (min-width: 992px) {
      .carddiv {
        width: 70%;
      }
      .col {
        margin-right: 3px;
      }
      .card-img-top {
        border-radius: 7px;
        width: 140px;
        margin-bottom: 20px;
       }
       .col-md-2 {
        margin-right: 5px;
       }
       .formatcards {
        padding-left: 20px;
       }
     }
     
     /* Extra large devices (large laptops and desktops, 1200px and up) */
     @media only screen and (min-width: 1200px) {
   
      .card-img-top {
        border-radius: 7px;
        width: 200px;
        margin-bottom: 20px;
        margin-left: 50px;
       }
       .col-md-2 {
        margin-right: 5px;
       }
    }
    
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
    .card-img-top {
      border-radius: 7px;
      width: 200px;
      margin-bottom: 20px;
     }
     .col-md-2 {
      margin-right: 5px;
     }
  }
    
      /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {
  
}
     
</style>